import { ArrowUpIconTwoTone, Backdrop } from '@room-match/shared-ui-components';
import RoleDetails from 'pages/PastSelfTapes/PastSelfTape/RoleDetails/RoleDetails';
import { useMemo, useState } from 'react';
import { useSetHeaderBack } from 'shared/hooks/useSetHeader';
import { auditionScheduleService } from 'shared/services/auditionScheduleService';
import {
  Body,
  DetailsMainContainer,
  HeaderCont,
  LeftContainer,
  MainCont,
  ProjectRoleCont,
  RightContainer,
} from './AuditionRequest.styles';
import Response from './Response/Response';
import ProjectRoleInfo from './ProjectRoleInfo/ProjectRoleInfo';
import { CustomTypography } from 'shared/elements/CustomTypography';
import { IconButton } from '@material-ui/core';

type Props = {
  auditionScheduleId: string;
  prev?: boolean;
};

const { getSpecificAuditionSchedule } = auditionScheduleService();
const AuditionRequestDetails: React.FC<Props> = ({ auditionScheduleId, prev }) => {
  const [expanded, setexpanded] = useState(true);
  const { data: auditionScheduleData, isLoading } = getSpecificAuditionSchedule(auditionScheduleId);

  const getAuditionScheduleData = useMemo(() => {
    if (isLoading) {
      return;
    } else {
      return auditionScheduleData ? auditionScheduleData?.data.audition_schedule : undefined;
    }
  }, [auditionScheduleData, isLoading]);

  const getRoleDetailsData = useMemo(() => {
    if (isLoading) {
      return;
    } else {
      return getAuditionScheduleData ? getAuditionScheduleData?.audition.casting_role : undefined;
    }
  }, [getAuditionScheduleData, isLoading]);

  useSetHeaderBack(true);
  if (isLoading) return <Backdrop isLoading={true} />;
  if (!auditionScheduleData?.data.audition_schedule) return <>Invalid Audition Schedule ID</>;

  const handleChange = () => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
    setTimeout(() => {
      setexpanded(isExpanded);
    }, 200);
  };

  return (
    <MainCont>
      <RightContainer>
        <Response
          data={auditionScheduleData.data.audition_schedule}
          isSelftape={
            auditionScheduleData.data.audition_schedule.phase === 'Self Tapes Request' ||
            auditionScheduleData.data.audition_schedule.phase === 'Self Tapes Process'
          }
        />
      </RightContainer>
      <ProjectRoleCont onChange={handleChange()} defaultExpanded={true}>
        {/* <HeaderCont
          className="collapse"
          expandIcon={<ArrowUpIconTwoTone style={{ width: 16, height: 16, transform: 'rotate(180deg)' }} />}
        >
          <CustomTypography>Project / Role Information</CustomTypography>
          <CustomTypography>{expanded ? 'Collapse' : 'Expand'}</CustomTypography>
        </HeaderCont>
        <Body> */}
        <ProjectRoleInfo auditionSchedule={auditionScheduleData.data.audition_schedule} />
        {/* </Body> */}
      </ProjectRoleCont>

      {/* <RoleDetails data={getRoleDetailsData} /> */}
    </MainCont>
  );
};

export default AuditionRequestDetails;
